export default defineNuxtPlugin(() => {
  if (process.client) {
    const router = useRouter();
    router.options.scrollBehavior = (to, from, savedPosition) => {
      // При первой загрузке или если обновляется страница с хешом — не скроллить
      if (from.path === to.path || from.hash === to.hash) {
        return false;
      }

      if (savedPosition) {
        return savedPosition;
      }

      if (to.hash) {
        return {
          el: to.hash,
          behavior: "smooth"
        };
      }

      return { top: 0 };
    };
  }
});
